export const REGEXP_EMAIL = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/gi;
export const REGEXP_HEX = /^#([0-9A-F]{3}){1,2}$/i;
export const REGEXP_CATALOG_NAME = /^[a-z0-9]+(-[a-z0-9]+)*$/g;
export const REGEXP_START_NUMBER = /^[0-9]+/gi;
